<template>
	<div class="service">
		<router-view v-wechat-title="$route.meta.title"></router-view>
	</div>
</template>

<script>
  export default {
    name:'service',
    data: function () {
      return {}
    },
    created: function () {

    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/service/index.vue